export const GET_MOSQUES_REQUEST = 'GET_MOSQUES_REQUEST'
export const GET_MOSQUES = 'GET_MOSQUES'
export const GET_MOSQUES_REQUEST_PENDING = 'GET_MOSQUES_REQUEST_PENDING'
export const GET_MOSQUES_REQUEST_SUCCESS = 'GET_MOSQUES_REQUEST_SUCCESS'
export const GET_MOSQUES_REQUEST_ERROR = 'GET_MOSQUES_REQUEST_ERROR'
export const GET_SUP_MOSQUES_REQUEST = 'GET_SUP_MOSQUES_REQUEST'
